export default __webpack_public_path__ + "static/media/module.eeac47ad.jpg";